import Parts from '../../componnets/parts/Parts';
import './competition.css';

export default function Competition({setParts , parts}) {
    const partir = [
        { id: 1, image: 'http://dl.mahoganyacademy.de/compotition/5mordad.jpeg', time: 'پنجم مرداد' , description: 'مسابقه کشوری میکاپ' },
        { id: 2, video: 'http://dl.mahoganyacademy.de/compotition/19mordad.mp4', time: 'نوزدهم مرداد' , description: 'مسابقه کشوری کراتین دوره دوم' },
        { id: 2, video: 'http://dl.mahoganyacademy.de/compotition/15tir.mp4', time: 'پانزدهم تیر' , description: 'مسابقه کشوری کراتین دوره اول' },
    ];
    const partnotir = [

    ];
    function changingports(){
        parts === 'ir' ? setParts('notir') : setParts('ir');
    }
    return (
        <div className="competitionpage">
                        <div className='changeparts' style={{display: parts === '' ? 'none' : 'inline-block'}} onClick={changingports}>{parts === 'ir' ? 'خارجی' : 'داخلی'}</div>
                        {parts === '' ? <Parts setParts={setParts} /> : 
            <div className="competitioncontainer">
                {parts === 'ir' ? 
                                partir.map((comp) => (
                                    <div key={comp.id} className="competitionitem">
                                        {comp.video ? <video src={comp.video} controls /> : <img src={comp.image} loading='lazy' alt={comp.description}></img>}
                                        <h3>{comp.description}</h3>
                                        <p>{comp.time}</p>
                                    </div>
                                )) : 
                                partnotir.map((comp) => (
                                    <div key={comp.id} className="competitionitem">
                                        {comp.video ? <video src={comp.video} controls /> : <img src={comp.image} loading='lazy' alt={comp.description}></img>}
                                        <h3>{comp.description}</h3>
                                        <p>{comp.time}</p>
                                    </div>
                                ))}
            </div>
}
        </div>
    );
}
